import React, { Fragment } from "react";
import PageContainer from "../../../components/page-container/PageContainer";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { Loading } from "../../../components/loading/Loading";
import {
  Button,
  ButtonGroup,
  Grid,
  Dialog
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getForms, deleteForms, setCurrentFormTitle } from "../../../state/actions/FormsActions";
import SimpleTable from "../../../components/table/Table";
import Search from "../../../components/search/Search";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import { NewEntityDialog } from "../../../containers/new-entity-dialog/NewEntityDialog";
import { withTranslation } from "react-i18next";

class ListFormsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      originalData: [],
      searchedData: [],
      selectedFormIds: [],
      forms: props.forms,
      newFormModalOpen: false
    };
  }

  componentDidMount() {
    this.setupData();
  }

  componentWillUnmount() {
    // this.props.setNewFormTitle("", () => { })
  }

  componentDidUpdate() {
    if (JSON.stringify(this.state.forms) !== JSON.stringify(this.props.forms)) {
      const data = Object.keys(this.props.forms).map(formKey => {
        return this.props.forms[formKey];
      });

      this.setState({
        originalData: data,
        searchedData: data,
        forms: this.props.forms
      });
    }
  }

  setupData() {
    this.setState({ loading: true });

    this.props.getForms(() => {
      const data = [];
      Object.keys(this.props.forms).forEach(formKey => {
        const form = this.props.forms[formKey];
        data.push({ id: form.id, Name: form.Name });
      });

      this.setState({
        loading: false,
        searchedData: data,
        originalData: data
      });
    });
  }

  createHeaders() {
    return [
      {
        id: "Name",
        clickable: true,
        action: { path: "/forms/edit/{id}", identifier: "id" },
        align: "left",
        label: this.props.t('form.name')
      },
      {
        id: "id",
        clickable: false,
        align: "left",
        label: this.props.t('form.form-id')
      },
      {
        id: "Description",
        clickable: false,
        align: "left",
        label: this.props.t('common.description')
      }
    ];
  }

  createCells(headers) {
    let cells = [];

    headers.forEach(header => {
      let cell = { id: header.id };

      if (header.hasOwnProperty("action")) {
        cell.handleClick = (event, row) => {
          let path = header.action.path.replace(
            "{id}",
            row[header.action.identifier]
          );
          this.props.history.push(path);
        };
      }

      cell.align = header.align;
      cell.clickable = header.clickable;

      cells.push(cell);
    });

    return cells;
  }

  renderList() {
    const headers = this.createHeaders();
    const cells = this.createCells(headers);

    return (
      <SimpleTable
        handleSelection={selectedIds => {
          this.setState({ selectedFormIds: selectedIds });
        }}
        dataId={"id"}
        headers={headers}
        cells={cells}
        isSelectable={true}
        rows={this.state.searchedData}
      />
    );
  }

  alertDialog() {
    return (
      <AlertDialog
        title={this.props.t('common.remove-question')}
        description={this.props.t("common.remove-description")}
        options={[
          {
            label: this.props.t('common.cancel'),
            action: () => this.setState({ deleteAlertShowing: false })
          },
          { label: this.props.t('common.delete'), action: () => this.handleDelete() }
        ]}
        isOpen={this.state.deleteAlertShowing}
      />
    );
  }

  handleDelete() {
    this.props.deleteForms(this.state.selectedFormIds, () => {
      this.setState({ deleteAlertShowing: false, selectedFormIds: [] });
    });
  }

  newFormDialog() {
    return (
      <NewEntityDialog
        dialogTitle={this.props.t('form.create-new-form')}
        confirmLabel={this.props.t('common.create')}
        onCancel={() => this.setState({ newFormModalOpen: false })}
        onConfirm={() => {
          this.setState({ newFormModalOpen: false })
          this.props.history.push("/forms/new")
        }}
        onTitleChange={(value) => this.props.setCurrentFormTitle(value, () => { })}
        isOpen={this.state.newFormModalOpen}
        title={this.props.currentForm != null ? this.props.currentForm.Name : ""}
      />
    )
  }

  render() {
    return (
      <Fragment>
        {this.alertDialog()}
        <HeaderBlock
          title={this.props.t('form.forms')}
          right={
            <Grid container spacing={2} alignItems="center" justify="flex-end">
              <Grid item>
                <Search
                  searchField={"Name"}
                  secondaryFields={["id"]}
                  returnSearchMatches={data => {
                    this.setState({ searchedData: data });
                  }}
                  data={this.state.originalData}
                  searchTitle={this.props.t('form.search')}
                />
              </Grid>
              <Grid item>
                <ButtonGroup>
                  <Button
                    disabled={this.state.selectedFormIds.length === 0}
                    onClick={() => this.setState({ deleteAlertShowing: true })}
                    variant="outlined"
                    color="primary"
                  >
                    {this.props.t('common.delete')}
                  </Button>
                  <Button
                    onClick={() =>
                      this.setState({ newFormModalOpen: true })
                    }
                    variant="outlined"
                    color="secondary"
                  >
                    {this.props.t('form.new')}
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          }
        />
        {this.newFormDialog()}
        <PageContainer hasFooter>
          {this.state.loading ? <Loading /> : this.renderList()}
        </PageContainer>
      </Fragment>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { forms, currentForm } = state.FormsReducer;
  return { forms, currentForm };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getForms, deleteForms, setCurrentFormTitle }, dispatch);

const hoc = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListFormsPage))
);

// EXPORT COMPONENT

export { hoc as ListFormsPage };
